export const Chemostratigpraphy = [
  { prop: 'id', label: 'Id' },
  { prop: 'section_Or_Borehole', label: 'Section Or Borehole' },
  { prop: 'latitude', label: 'Latitude' },
  { prop: 'longitude', label: 'Longitude' },
  { prop: 'paleolatitude', label: 'Paleolatitude' },
  { prop: 'paleolongitude', label: 'Paleolongitude' },
  { prop: 'country', label: 'Country' },
  { prop: 'province', label: 'Province' },
  { prop: 'formation', label: 'Formation' },
  { prop: 'epoch', label: 'Epoch' },
  { prop: 'stage', label: 'Stage' },
  // {
  //   prop: 'proxy_Carbon_isotope_excursion',
  //   label: 'Proxy (Carbon isotope excursion)',
  // },
  { prop: 'proxy', label: 'Proxy' },
  { prop: 'excursion_starting_depth', label: 'Excursion starting depth (m)' },
  { prop: 'excursion_termination_depth', label: 'Excursion termination depth (m)' },
  { prop: 'degree_of_excursion', label: 'Degree of excursion (‰)' },
  { prop: 'excursion_time_kyr', label: 'Excursion-time (kyr)' },
  { prop: 'data_resource', label: 'Data resourse' },
  { prop: 'year', label: 'Year' },
  { prop: 'reference', label: 'Reference' },
  { prop: 'comments', label: 'Comments' },
  { prop: 'processed_By', label: 'Processed_By' },
  { prop: 'reviewed_By', label: 'Reviewed_ By' },
];

export const Chronostratigraphy = [
  { prop: 'id', label: 'Id' },
  { prop: 'section_Or_Borehole',label: 'Section Or Borehole',},
  { prop: 'latitude', label: 'Latitude' },
  { prop: 'longitude', label: 'Longitude' },
  { prop: 'paleolatitude', label: 'Paleolatitude' },
  { prop: 'paleolongitude', label: 'Paleolongitude' },
  { prop: 'country', label: 'Country' },
  { prop: 'province', label: 'Province' },
  { prop: 'formation', label: 'Formation' },
  { prop: 'epoch', label: 'Epoch' },
  { prop: 'stage', label: 'Stage' },
  { prop: 'depth', label: 'Depth (m)' },
  { prop: 'top_Depth', label: 'Top_Depth (m)' },
  { prop: 'bot_Depth', label: 'Bot_Depth (m)' },
  { prop: 'chrono_Type', label: 'Chrono_Type' },
  { prop: 'event_Type', label: 'Event_Type' },
  { prop: 'event_Name', label: 'Event_Name' },
  { prop: 'age', label: 'Age (Ma)' },
  { prop: 'error', label: 'Error (Ma)' },
  { prop: 'age_Min', label: 'Age_Min (Ma)' },
  { prop: 'age_Max', label: 'Age_Max (Ma)' },
  { prop: 'Age_standard', label: 'Age standard' },
  { prop: 'year', label: 'Year' },
  { prop: 'reference', label: 'Reference' },
  { prop: 'comments', label: 'Comments' },
  { prop: 'processed_By', label: 'Processed_By' },
  { prop: 'reviewed_By', label: 'Reviewed_ By' },
];
export const Cyclostratigraphy = [
  { prop: 'id', label: 'Id' },
  { label: 'Section Or Borehole', prop: 'section_Or_Borehole' },
  { prop: 'latitude', label: 'Latitude' },
  { prop: 'longitude', label: 'Longitude' },
  { prop: 'paleolatitude', label: 'Paleolatitude' },
  { prop: 'paleolongitude', label: 'Paleolongitude' },
  { prop: 'country', label: 'Country' },
  { prop: 'province', label: 'Province' },
  { prop: 'formation', label: 'Formation' },
  { prop: 'epoch', label: 'Epoch' },
  { prop: 'stage', label: 'Stage' },
  { prop: 'top_depth', label: 'Top_Depth (m)'},
  { prop: 'bot_Depth', label: 'Bot_Depth (m)'},
  { prop: 'thickness', label: 'Thickness (m)'},
  { prop: 'detrending_method', label: 'Detrending method'},
  { prop: 'proxy_Cyclostratigraphic_analysis', label: 'Proxy (Cyclostratigraphic analysis)' },
  { prop: 'spectrum_analysis_method', label: 'Spectrum analysis method' },
  { prop: 'sedimentation_rate_detection_method', label: 'Sedimentation rate detection method' },
  { prop: 'Sedimentation_rate_cm_kyr', label: 'Sedimentation rate (cm/kyr)' },
  { prop: 'tuned_main_cycle', label: 'Tuned main Cycle (kyr)' },
  { prop: 'fats', label: 'FATS (kyr)' },
  { prop: 'anchor_point_depth', label: 'Anchor point depth (m)' },
  { prop: 'anchor_age', label: 'Anchor age (Ma)' },
  { prop: 'ats', label: 'ATS (kyr)' },
  { prop: 'proxy_Carbon_isotope_excursion', label: 'Proxy (Carbon isotope excursion)' },
  { prop: 'excursion_starting_depth', label: 'Excursion  starting depth (m)' },
  { prop: 'excursion_termination_depth', label: 'Excursion termination depth (m)' },
  { prop: 'degree_of_excursion', label: 'Degree of excursion (‰）' },
  { prop: 'excursion_time', label: 'Excursion-time (kyr)' },
  { prop: 'data_resourse', label: 'Data resourse' },
  { prop: 'year', label: 'Year' },
  { prop: 'reference', label: 'Reference' },
  { prop: 'comments', label: 'Comments' },
  { prop: 'processed_By', label: 'Processed_By' },
  { prop: 'reviewed_By', label: 'Reviewed_ By' },
];
export const lithology = [
  { prop: 'id', label: 'Id' },
  { prop: 'section_Or_Borehole', label: 'Section Or Borehole' },
  { prop: 'latitude', label: 'Latitude' },
  { prop: 'longitude', label: 'Longitude' },
  { prop: 'paleolatitude', label: 'Paleolatitude' },
  { prop: 'paleolongitude', label: 'Paleolongitude' },
  { prop: 'country', label: 'Country' },
  { prop: 'province', label: 'Province' },
  { prop: 'formation', label: 'Formation' },
  { prop: 'epoch', label: 'Epoch' },
  { prop: 'stage', label: 'Stage' },
  { prop: 'top_depth', label: 'Top_Depth (m)' },
  { prop: 'bot_Depth', label: 'Bot_Depth (m)' },
  { prop: 'thickness', label: 'Thickness (m)' },
  { prop: 'lithology', label: 'Lithology' },
  { prop: 'sedimentary_environment', label: 'Sedimentary environment' },
  { prop: 'sedimentary_subfacies', label: 'Sedimentary subfacies' },
  { prop: 'year', label: 'Year' },
  { prop: 'reference', label: 'Reference' },
  { prop: 'comments', label: 'Comments' },
  { prop: 'processed_By', label: 'Processed_By' },
  { prop: 'reviewed_By', label: 'Reviewed_By' },
];
